// extracted by mini-css-extract-plugin
export default {"tables_wrapper":"ReportTableAnalysisPage_tables_wrapper__rqlFk","open_drawer":"ReportTableAnalysisPage_open_drawer__bQo4W"};